var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuBook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 211,
    height: 211,
    viewBox: "0 0 211 211",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_59_138)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.625 43.9583C174.866 40.8812 164.14 39.5625 153.854 39.5625C136.71 39.5625 118.248 43.0792 105.5 52.75C92.752 43.0792 74.2895 39.5625 57.1458 39.5625C40.002 39.5625 21.5395 43.0792 8.79163 52.75V181.548C8.79163 183.746 10.9895 185.944 13.1875 185.944C14.0666 185.944 14.5062 185.504 15.3854 185.504C27.2541 179.79 44.3979 175.833 57.1458 175.833C74.2895 175.833 92.752 179.35 105.5 189.021C117.369 181.548 138.908 175.833 153.854 175.833C168.36 175.833 183.306 178.471 195.615 185.065C196.494 185.504 196.933 185.504 197.812 185.504C200.01 185.504 202.208 183.306 202.208 181.108V52.75C196.933 48.7937 191.219 46.1562 184.625 43.9583ZM184.625 162.646C174.954 159.569 164.404 158.25 153.854 158.25C138.908 158.25 117.369 163.965 105.5 171.437V70.3333C117.369 62.8604 138.908 57.1458 153.854 57.1458C164.404 57.1458 174.954 58.4646 184.625 61.5417V162.646Z",
    fill: "#F2CC8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.854 92.3125C161.591 92.3125 169.064 93.1038 175.833 94.5983V81.235C168.888 79.9162 161.415 79.125 153.854 79.125C138.908 79.125 125.369 81.6746 114.292 86.4221V101.016C124.226 95.3896 138.029 92.3125 153.854 92.3125Z",
    fill: "#F2CC8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.292 109.808V124.402C124.226 118.775 138.029 115.698 153.854 115.698C161.591 115.698 169.064 116.489 175.833 117.984V104.621C168.888 103.302 161.415 102.511 153.854 102.511C138.908 102.511 125.369 105.148 114.292 109.808Z",
    fill: "#F2CC8F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.854 125.985C138.908 125.985 125.369 128.534 114.292 133.282V147.876C124.226 142.249 138.029 139.172 153.854 139.172C161.591 139.172 169.064 139.963 175.833 141.458V128.095C168.888 126.688 161.415 125.985 153.854 125.985Z",
    fill: "#F2CC8F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_59_138"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 211,
    height: 211,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBook);
export default __webpack_public_path__ + "static/media/menu_book.9d5fef674fbc24480526deb09c45dab3.svg";
export { ForwardRef as ReactComponent };